<template>
  <div class="confirm-and-create">
    <div class="titulo"></div>

    <div class="card-box full">
      <div class="center">
        <h1>Concluído.</h1>
      </div>

      <form :action="PADMONEY_URL">
        <div>
          <p class="center">
            Tudo certo! O seu cadastro foi concluído com sucesso.
          </p>
          <p class="center email padding">
            Enviamos um e-mail com as instruções para confirmar os dados de sua conta no Padmoney.
          </p>
          <p class="center email">
            Caso não veja o nosso e-mail em sua caixa de entrada, verifique no seu spam.
          </p>
          <p class="center">
            Seja bem-vindo ao Padmoney!
          </p>
          <ContinueSection continue-text="Acessar Sistema"/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ContinueSection from '@/components/ContinueSection'

const PADMONEY_URL = process.env.VUE_APP_PADMONEY_URL

export default {
  name: 'Completed',
  components: { ContinueSection },
  data: () => ({ PADMONEY_URL })
}
</script>

<style scoped lang="scss">
  .card-box {
    max-width: 800px !important;

    form {
      p {
        font-size: 1.3em;
        font-weight: lighter;
        margin: 15px;

        &.email {
          font-size: 1em;
          margin: 0;
          color: #3696f1;

          &.padding {
            margin-top: 15px;
          }
        }
      }
    }
  }
</style>
